import {
  eachDayOfInterval,
  endOfMonth,
  getDay,
  getDaysInMonth,
  isSameDay,
  setDate,
  startOfDay,
  isWithinInterval,
} from 'date-fns';
import { Dispatch } from 'react';
import styled from 'styled-components';
import { now } from '../../../common/util/now';
import { range } from '../../../common/util/range';
import { CalendarDate } from '../CalendarDate/CalendarDate';

interface Props {
  currentDate: Date;
  disableWhitelist?: boolean;
  whitelistDates: Date[];
  lastDate: Date;
  month: Date;
  onChange?: Dispatch<Date>;
  value?: Date;
  endValue?: Date;
}

const dateIn = (date: Date, dates: Date[]) =>
  !!dates.find((subDate: Date) => isSameDay(subDate, date));

const MultiPadding = ({ number }: { number: number }) => (
  <>
    {range(number).map(i => (
      <Padding key={i} />
    ))}
  </>
);

export const CalendarGrid = ({
  currentDate = now(),
  disableWhitelist = false,
  whitelistDates = [],
  lastDate,
  month,
  onChange,
  value,
  endValue,
}: Props) => {
  const allDates = eachDayOfInterval({ start: setDate(month, 1), end: endOfMonth(month) });
  const startGaps = getDay(setDate(month, 1));
  const endGaps = 42 - getDaysInMonth(month) - startGaps;
  return (
    <Grid>
      <MultiPadding number={startGaps} />

      {allDates.map(date => {
        const selected =
          (!!value && isSameDay(date, value)) ||
          (!!endValue && isSameDay(date, endValue)) ||
          (!!value && !!endValue && isWithinInterval(date, { start: value, end: endValue }));

        return (
          <CalendarDate
            date={date}
            past={date < startOfDay(currentDate) || (!disableWhitelist && date > lastDate)}
            selected={selected}
            unavailable={disableWhitelist ? false : !dateIn(date, whitelistDates)}
            onSelect={onChange}
            key={date.getTime()}
          />
        );
      })}

      <MultiPadding number={endGaps} />
    </Grid>
  );
};

const Grid = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const Padding = styled.div`
  flex: 0 0 14%;
`;
